import React from 'react';
import { motion } from 'framer-motion';
import { Image as ImageIcon } from 'lucide-react';
const images = ['https://images.unsplash.com/photo-1595476108010-b4d1f10d5e43?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1522337660859-02fbefca4702?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1600948836101-f9ffda59d250?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1580618672591-eb180b1a973f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1560869713-7d0a29430803?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'];
export function Gallery() {
  return <section id="gallery" className="py-32 bg-white" data-id="element-140">
      <div className="container mx-auto px-6 md:px-12" data-id="element-141">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-16 gap-6 md:gap-0" data-id="element-142">
          <div data-id="element-143">
            <h2 className="font-heading text-4xl md:text-5xl font-semibold tracking-tight text-ink mb-6" data-id="element-144">
              Мої роботи
            </h2>
            <div className="w-12 h-1 bg-ink rounded-full" data-id="element-145"></div>
          </div>
          <a href="#instagram" className="text-sm font-medium text-ink border-b border-ink pb-1 hover:text-muted hover:border-muted transition-colors" data-id="element-146">
            Дивитись більше
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 auto-rows-[300px]" data-id="element-147">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          ease: 'easeOut'
        }} className="md:col-span-2 md:row-span-2 relative group overflow-hidden bg-surface rounded-[2rem] border border-line flex items-center justify-center shadow-sm hover:shadow-xl transition-shadow duration-500" data-id="element-148">
            <div className="absolute inset-0 transition-transform duration-700 ease-out group-hover:scale-[1.03] flex items-center justify-center" data-id="element-149">
              <div className="text-center flex flex-col items-center" data-id="element-150">
                <ImageIcon className="text-muted mb-3" size={32} strokeWidth={1.5} data-id="element-151" />
                <p className="text-xs text-muted font-medium tracking-widest uppercase" data-id="element-152">
                  Фото роботи
                </p>
              </div>
            </div>
            <div className="absolute inset-0 bg-black/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-153"></div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1,
          ease: 'easeOut'
        }} className="relative group overflow-hidden bg-surface rounded-[2rem] border border-line flex items-center justify-center shadow-sm hover:shadow-xl transition-shadow duration-500" data-id="element-154">
            <div className="absolute inset-0 transition-transform duration-700 ease-out group-hover:scale-[1.03] flex items-center justify-center" data-id="element-155">
              <div className="text-center flex flex-col items-center" data-id="element-156">
                <ImageIcon className="text-muted mb-3" size={24} strokeWidth={1.5} data-id="element-157" />
                <p className="text-xs text-muted font-medium tracking-widest uppercase" data-id="element-158">
                  Фото роботи
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative group overflow-hidden bg-surface rounded-[2rem] border border-line flex items-center justify-center shadow-sm hover:shadow-xl transition-shadow duration-500" data-id="element-159">
            <div className="absolute inset-0 transition-transform duration-700 ease-out group-hover:scale-[1.03] flex items-center justify-center" data-id="element-160">
              <div className="text-center flex flex-col items-center" data-id="element-161">
                <ImageIcon className="text-muted mb-3" size={24} strokeWidth={1.5} data-id="element-162" />
                <p className="text-xs text-muted font-medium tracking-widest uppercase" data-id="element-163">
                  Фото роботи
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.3,
          ease: 'easeOut'
        }} className="md:col-span-2 relative group overflow-hidden bg-surface rounded-[2rem] border border-line flex items-center justify-center shadow-sm hover:shadow-xl transition-shadow duration-500" data-id="element-164">
            <div className="absolute inset-0 transition-transform duration-700 ease-out group-hover:scale-[1.03] flex items-center justify-center" data-id="element-165">
              <div className="text-center flex flex-col items-center" data-id="element-166">
                <ImageIcon className="text-muted mb-3" size={24} strokeWidth={1.5} data-id="element-167" />
                <p className="text-xs text-muted font-medium tracking-widest uppercase" data-id="element-168">
                  Фото роботи
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}